import { render, staticRenderFns } from "./JobListCard.vue?vue&type=template&id=1d1a6520&scoped=true&"
import script from "./JobListCard.vue?vue&type=script&lang=ts&"
export * from "./JobListCard.vue?vue&type=script&lang=ts&"
import style0 from "./JobListCard.vue?vue&type=style&index=0&id=1d1a6520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a6520",
  null
  
)

export default component.exports